import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import IbanListFilters from "../../components/Filters/ibanListFilters";
import DeleteModal from "../../components/modals/DeleteModal";
import ModalAddIban from "../../components/modals/ModalAddIban";
import TableFiltersSkeleton from "../../components/skeletons/TableFiltersSkeleton";
import IbanTable from "../../components/table/IbanTable";
import { BANKLIST } from "../../config/cacheKey";
import { ApiResultModel, PageInfoModel } from "../../models/common.model";
import {
  GetIbanResponse,
  IbanFilter,
  IbanRequest,
} from "../../models/iban.model";
import { PaginationInfo } from "../../models/security.model";
import { GetBanks } from "../../services/basicInformation.service";
import {
  CreateIban,
  DeleteIban,
  GetIbanExcel,
  GetIbans,
} from "../../services/iban.service";

const Iban = () => {
  const [showFilter, setShowFilter] = useState(true);
  const [filterObject, setFilterObject] = useState<IbanFilter>();
  const [ibanList, setIbanList] = useState<GetIbanResponse[]>([]);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openAddIbanModal, setOpenAddIbanModal] = useState(false);
  const [selectedRowId, setSelectedRowId] = useState<number>();
  const queryClient = useQueryClient();
  const history = useHistory<{
    id: number;
  }>();

  const handleExportExcel = () => {
    GetIbanExcelMutate({
      ...filterObject,
    });
  };
  const handleDelete = (id: number) => {
    setOpenDeleteModal(true);
    setSelectedRowId(id);
  };
  const handleDeleteRcord = () => {
    DeleteIbanMutate({ id: selectedRowId! });
  };

  const handleAddRcord = (value: IbanRequest) => {
    value.iban = "IR" + value.iban;
    CreateIbanMutate(value);
  };
  const handleRouteToBranchDetail = (rowId: number) => {
    history.push({
      pathname: "/store/Iban/AssignBranchToIban",
      state: {
        id: rowId,
      },
    });
    localStorage.setItem("BRANCH_IBANID", String(rowId));
  };
  const [currentPaginationInfo, setCurrentPaginationInfo] = useState(
    (): PaginationInfo => {
      let paginationInfo = {} as PaginationInfo;
      paginationInfo.pageNumber = 1;
      paginationInfo.pageSize = 10;
      return paginationInfo;
    },
  );
  const [pageInfo, setPageInfo] = useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 10;
      pageInfoModel.total = 0;
      return pageInfoModel;
    },
  );
  const { mutate: GetIbansMutate } = useMutation(GetIbans, {
    onSuccess: (data: ApiResultModel<GetIbanResponse[]>) => {
      if (data) {
        setIbanList(data.data);
        setPageInfo(data.pageInfo);
      }
    },
    onError: () => {},
  });

  const { mutate: GetIbanExcelMutate } = useMutation(GetIbanExcel, {
    onSuccess: (data: any) => {
      if (data) {
      }
    },
    onError: () => {},
  });

  const { data: banks, isLoading } = useQuery("GetBanks", GetBanks, {
    staleTime: 1000 * 60 * 30,
    cacheTime: 1000 * 60 * 60,
    refetchOnWindowFocus: false,
  });

  queryClient.setQueryData(BANKLIST, banks);
  const { mutate: DeleteIbanMutate } = useMutation(DeleteIban, {
    onSuccess: (data: boolean) => {
      if (data) {
        GetIbansMutate({
          filter: filterObject,
          paginationInfo: currentPaginationInfo,
        });
        setOpenDeleteModal(false);
        toast.error("شماره شبا با موفقیت حذف گردید");
      }
    },
    onError: () => {},
  });
  const { mutate: CreateIbanMutate } = useMutation(CreateIban, {
    onSuccess: (data: boolean) => {
      if (data) {
        setOpenAddIbanModal(false);
        GetIbansMutate({
          filter: filterObject,
          paginationInfo: currentPaginationInfo,
        });
        toast.success("شماره شبا با موفقیت افزوده شد");
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    GetIbansMutate({
      filter: filterObject,
      paginationInfo: currentPaginationInfo,
    });
  }, [filterObject, currentPaginationInfo]);
  return (
    <div>
      <Grid container>
        <Grid
          item
          sx={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Typography
              color={"#1565C0"}
              fontWeight={"bold"}
              padding={"0.5rem"}
              borderRadius={"5px"}
              sx={{
                cursor: "pointer",
                width: "fit-content",
                "&: hover": { color: "#fff", background: "#1565C0" },
              }}
              onClick={() => {
                setOpenAddIbanModal(true);
              }}
            >
              <AddCircleOutlineIcon sx={{ marginLeft: "7px" }} />
              افزودن شماره شبا
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              borderLeft: "2px solid #DAE0E4",
              paddingLeft: "10px",
              cursor: "pointer",
            }}
          >
            <Tooltip title="فیلتر" arrow>
              <img
                onClick={() => setShowFilter((prev) => !prev)}
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/filter.png"
                alt=""
              />
            </Tooltip>
          </Box>
          <Box
            sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}
          >
            <Tooltip title="خروجی اکسل" arrow>
              <img
                onClick={handleExportExcel}
                className="cursorPointer"
                style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
                src="images/ExportXLS.svg"
                alt="ExportXLS"
              />
            </Tooltip>
          </Box>
        </Grid>
        {showFilter &&
          (!isLoading ? (
            <Grid item xs={12} sx={{ marginBottom: "20px" }}>
              <IbanListFilters
                filterObject={filterObject!}
                setFilterObject={setFilterObject}
                setCurrentPaginationInfo={setCurrentPaginationInfo}
              />
            </Grid>
          ) : (
            <span style={{ marginBottom: "10px", width: "100%" }}>
              <TableFiltersSkeleton />
            </span>
          ))}
        <Grid item xs={12}>
          <IbanTable
            ibansList={ibanList}
            pageInfo={pageInfo}
            currentPaginationInfo={currentPaginationInfo}
            setCurrentPaginationInfo={setCurrentPaginationInfo}
            handelDelete={handleDelete}
            handleRouteToBranchDetail={handleRouteToBranchDetail}
          />
        </Grid>
      </Grid>
      <DeleteModal
        openDeleteModal={openDeleteModal}
        setOpenDeleteModal={setOpenDeleteModal}
        text={
          <>
            آیا از <span style={{ color: "#E6123D" }}>حذف این شماره شبا</span>{" "}
            اطمینان دارید؟
          </>
        }
        handleDel={handleDeleteRcord}
        onCloseModal={() => setOpenDeleteModal(false)}
      />
      <ModalAddIban
        handleAdd={handleAddRcord}
        openAddIbanModal={openAddIbanModal}
        setOpenAddIbanModal={setOpenAddIbanModal}
      />
    </div>
  );
};

export default Iban;
